<template>
  <div class="quiz-final">
    <div class="quiz-final_row">
      <div class="quiz_header">
        <h2 class="quiz_heading">{{ $c('Викторина') }}</h2>
        <template v-if="correctCounter < 5">
          <h1
            class="heading1"
            v-html="
              $c(
                'У тебя %(correctCounter)s %(score)s. Есть к чему стремиться!',
                {correctCounter, score: $declension(correctCounter, ['балл', 'балла', 'баллов'])}
              )
            "
          />
        </template>
        <template v-else-if="correctCounter > 4 && correctCounter < 9">
          <h1
            class="heading1"
            v-html="
              $c(
                'У тебя %(correctCounter)s %(score)s. Отличный результат!',
                {correctCounter, score: $declension(correctCounter, ['балл', 'балла', 'баллов'])}
              )
            "
          />
        </template>
        <template v-else-if="correctCounter > 8">
          <h1
            class="heading1"
            v-html="
              $c(
                '%(correctCounter)s %(score)s из %(total)s возможных! Да ты просто танковый ас!',
                {total, correctCounter, score: $declension(correctCounter, ['балл', 'балла', 'баллов'])}
              )
            "
          />
        </template>
      </div>
    </div>
    <div class="quiz-final_row quiz-final_row__bordered">
      <div class="quiz-final_result">
        {{ $c('Тебе начислен %(quizSpins)s Шанс!', {quizSpins}) }}
      </div>
    </div>
    <div class="quiz-final_row">
      <div class="quiz-final_return-wrapper">
        <a @click="$root.$emit('closeRandomRewardsPopUp')" class="button contained">{{ $c('На страницу с заданиями') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const randomRewards = namespace('randomRewards')

@Component({
  components: {}
})
class Final extends Vue {
  @Prop({
    type: Number,
    required: true
  }) correctCounter
  @Prop({
    type: Number,
    required: true
  }) total
  @randomRewards.State('quizSpins') quizSpins
}

export default Final
</script>

<style lang="scss">
  .quiz-final {
    &_row {
      margin: 50px 0;
      padding: 0 60px;
      box-sizing: border-box;
      &__bordered {
        border-top: 1px solid #333333;
        border-bottom: 1px solid #333333;
      }
    }
    &_result {
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 25px;
      color: #3BB200;
      padding: 30px 0;
    }
  }
</style>
